import { render, staticRenderFns } from "./file-header.vue?vue&type=template&id=b17bde12&scoped=true"
import script from "./file-header.vue?vue&type=script&lang=js"
export * from "./file-header.vue?vue&type=script&lang=js"
import style0 from "./file-header.vue?vue&type=style&index=0&id=b17bde12&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17bde12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b17bde12')) {
      api.createRecord('b17bde12', component.options)
    } else {
      api.reload('b17bde12', component.options)
    }
    module.hot.accept("./file-header.vue?vue&type=template&id=b17bde12&scoped=true", function () {
      api.rerender('b17bde12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/auditionManage/file-header.vue"
export default component.exports